/* NAKR V206 — mobile UI state reset for Safari/iPhone bfcache/navigation safety */
(function () {
  function clearBodyLocks() {
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
    Array.from(document.body.classList).forEach(function (c) {
      if (c.indexOf('overflow-hidden-') === 0) document.body.classList.remove(c);
    });
  }

  function resetMenu() {
    document.querySelectorAll('header-drawer, menu-drawer').forEach(function (drawer) {
      drawer.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        var summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('.submenu-open').forEach(function (el) { el.classList.remove('submenu-open'); });
    });
    document.querySelectorAll('.section-header, .header-wrapper').forEach(function (el) { el.classList.remove('menu-open'); });
  }

  function resetSearch() {
    document.querySelectorAll('.header__search details[open], details-modal details[open]').forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('predictive-search[open]').forEach(function (el) { el.removeAttribute('open'); });
  }

  function resetCartDrawer() {
    document.querySelectorAll('cart-drawer').forEach(function (drawer) {
      drawer.classList.remove('active', 'animate');
      drawer.removeAttribute('open');
    });
    document.querySelectorAll('cart-drawer .drawer').forEach(function (el) { el.classList.remove('active', 'animate'); });
  }

  function resetTransientUI() {
    resetMenu();
    resetSearch();
    resetCartDrawer();
    var activeModal = document.querySelector('modal-dialog[open], product-modal[open], .nakr-popup.is-open, .nakr-lightbox.is-open, .nakr-qv.is-open');
    if (!activeModal) {
      clearBodyLocks();
      document.documentElement.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('menu-drawer a[href], header-drawer a[href]');
    if (link && !link.getAttribute('href').startsWith('#')) {
      resetMenu();
      clearBodyLocks();
    }
  }, true);

  window.addEventListener('pagehide', resetTransientUI);
  window.addEventListener('pageshow', function () {
    resetTransientUI();
    requestAnimationFrame(resetTransientUI);
    setTimeout(resetTransientUI, 80);
  });
  window.addEventListener('popstate', resetTransientUI);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetTransientUI();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetTransientUI, { once: true });
  } else {
    resetTransientUI();
  }
})();

/* NAKR V298 — robust mobile drawer + touch campaign interactions */
(function () {
  function unlockIfNoOverlay() {
    var menuOpen = document.querySelector('header-drawer details[open], menu-drawer details[open]');
    var cartOpen = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var modalOpen = document.querySelector('details-modal details[open], modal-dialog[open], product-modal[open], .nakr-popup.is-open, .nakr-lightbox.is-open, .nakr-qv.is-open');
    if (!menuOpen && !cartOpen && !modalOpen) {
      document.body.classList.remove('overflow-hidden');
      Array.from(document.body.classList).forEach(function (name) {
        if (name.indexOf('overflow-hidden-') === 0) document.body.classList.remove(name);
      });
      document.documentElement.classList.remove('overflow-hidden');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    }
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.closest('header-drawer, menu-drawer')) return;
    if (!details.open) {
      details.classList.remove('menu-opening');
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(unlockIfNoOverlay);
    }
  }, true);

  // Let the theme's native keyup handler close the menu and release its focus trap.
  // The toggle listener above clears stale scroll locks after the close animation.


  /* On touch devices, first tap reveals the CTA, second tap follows the link. */
  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var campaign = event.target.closest('body[data-page-type="index"] .shopify-section[id*="__nakr_editorial_links_home"] [id^="SekanyCampaign-"] a, body[data-page-type="index"] .shopify-section[id*="__campaigns"] [id^="SekanyCampaign-"] a');
    if (!campaign) return;
    if (!campaign.classList.contains('nakr-touch-reveal')) {
      event.preventDefault();
      document.querySelectorAll('.nakr-touch-reveal').forEach(function (el) {
        if (el !== campaign) el.classList.remove('nakr-touch-reveal');
      });
      campaign.classList.add('nakr-touch-reveal');
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[id^="SekanyCampaign-"] a')) return;
    document.querySelectorAll('.nakr-touch-reveal').forEach(function (el) { el.classList.remove('nakr-touch-reveal'); });
  });
})();
